export enum AsyncStatusesEnum {
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  FAILED = 'FAILED',
}

export function combineAsyncStatuses(...statuses: ReadonlyArray<AsyncStatusesEnum>): AsyncStatusesEnum {
  if (statuses.includes(AsyncStatusesEnum.FAILED)) {
    return AsyncStatusesEnum.FAILED;
  }

  if (statuses.includes(AsyncStatusesEnum.LOADING)) {
    return AsyncStatusesEnum.LOADING;
  }

  return AsyncStatusesEnum.LOADED;
}
